import React, { useState, useEffect } from "react";
import ButtonPage from "../ui/ButtonPage";

const ContactForm = () => {

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    jobtitle: "",
    company: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");


  useEffect(() => {
    if (successMessage) {
      const timer = setTimeout(() => {
        setSuccessMessage("");
      }, 5000);

      return () => clearTimeout(timer); // Cleanup timer
    }
  }, [successMessage]);

  const validateForm = () => {
    let newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.email.trim()) newErrors.email = "Email is required";
    if (!formData.phone.trim()) newErrors.phone = "Phone number is required";
    if (!formData.jobtitle.trim()) newErrors.jobtitle = "Job title is required";
    if (!formData.company.trim()) newErrors.company = "Company is required";
    if (!formData.message.trim()) newErrors.message = "Message is required";
    return newErrors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    // Remove error when user types
    if (errors[name]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }

    setTouched((prevTouched) => ({ ...prevTouched, [name]: true }));
  };

  const handleChange2 = (e, field) => {
    setFormData({ ...formData, [field]: e.target.value });

    // Remove error when user selects a value
    setErrors((prevErrors) => ({ ...prevErrors, [field]: "" }));
    setTouched((prevTouched) => ({ ...prevTouched, [field]: true }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Mark all fields as touched
    setTouched({
      name: true,
      email: true,
      phone: true,
      jobtitle: true,
      company: true,
      message: true,
    });

    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setIsSubmitting(false);
      return;
    }

    try {
      const response = await fetch(
        "https://happiestworkplaces.in/api/v1/emprole/saveHWAContactUs",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
        setSuccessMessage("Your message has been sent successfully!");
        setFormData({
          name: "",
          email: "",
          phone: "",
          jobtitle: "",
          company: "",
          message: "",
        });
        setErrors({});
        setTouched({});
      }
    } catch (error) {
      console.error("Error submitting form", error);
    }
    setIsSubmitting(false);
  };



  return (
    <div className="lg:w-3/5">
      <h2 className="text-3xl font-bold text-[#212121] capitalize pb-6">
        Fill in your details below & we will get back to you soon!
      </h2>

      {successMessage && <p className="text-green-600 mb-5 text-xl font-semibold">{successMessage}</p>}

      <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {[
          { name: "name", label: "Full Name", type: "text", placeholder: "Full Name" },
          { name: "email", label: "Email", type: "email", placeholder: "Email" },
          { name: "phone", label: "Phone Number", type: "text", placeholder: "Phone" },
          { name: "company", label: "Company/Organization", type: "text", placeholder: "Company" },
        ].map(({ name, label, type, placeholder }) => (
          <div key={name}>
            <label className="text-base font-medium text-[#212121] before:content-['*'] before:text-[#F14678] mb-1">
              {label}
            </label>
            <input
              className="w-full border border-[#212121] p-3 text-[#212121] rounded focus:outline-none focus:ring-1 focus:ring-[#212121]"
              type={type}
              name={name}
              placeholder={placeholder}
              value={formData[name]}
              onChange={handleChange}
            />
            {errors[name] && touched[name] && (
              <p className="pt-2 text-xs text-red-600 invalid-feedback">{errors[name]}</p>
            )}
          </div>
        ))}

        <div className="md:col-span-2">
          <label className="text-base font-medium text-[#212121] before:content-['*'] before:text-[#F14678] mb-1">
            Job Title
          </label>
          <select
            onChange={(e) => handleChange2(e, "jobtitle")}
            value={formData.jobtitle}
            className="w-full border border-[#212121] p-3 text-[#212121] rounded focus:outline-none focus:ring-1 focus:ring-[#212121] bg-white"
          >
            <option value="" disabled >Select One</option>
            <option value="Executive">Executive</option>
            <option value="Vice President">Vice President</option>
            <option value="Director">Director</option>
            <option value="Senior Manager">Senior Manager</option>
            <option value="Manager">Manager</option>
            <option value="Staff">Staff</option>
            <option value="President/Superintendent">President/Superintendent</option>
            <option value="Senior Administrator">Senior Administrator</option>
            <option value="Faculty/Staff/Educator">Faculty/Staff/Educator</option>
            <option value="Student">Student</option>
            <option value="Other">Other</option>
          </select>
          {errors.jobtitle && touched.jobtitle && (
            <p className="pt-2 text-xs text-red-600 invalid-feedback">{errors.jobtitle}</p>
          )}
        </div>

        <div className="md:col-span-2">
          <label className="text-base font-medium text-[#212121] before:content-['*'] before:text-[#F14678] mb-1">
            Message (If Any)
          </label>
          <textarea
            rows="4"
            className="w-full border border-[#212121] p-3 text-[#212121] rounded focus:outline-none focus:ring-1 focus:ring-[#212121]"
            name="message"
            placeholder="Message (If Any)"
            value={formData.message}
            onChange={handleChange}
          />
          {errors.message && touched.message && (
            <p className="pt-2 text-xs text-red-600 invalid-feedback">{errors.message}</p>
          )}
        </div>

        <ButtonPage type="submit" disabled={isSubmitting} text="Submit" />
      </form>
    </div>
  );
};

export default ContactForm;
